import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";

import HangupIcon from "@ht/shared/fonts/deos-pis/call-hangup";
import UnmuteIcon from "@ht/shared/fonts/deos-pis/mic";
import MuteIcon from "@ht/shared/fonts/deos-pis/mute";

import { ICallState, IIncomingMessage } from "../../../../app/call/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { callIncomingMessageReceived, callSendMessage, callStateChanged } from "../../../../app/call/callSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";
import { useDragging } from "../../../../hooks/useDragging";
import AudioAnalyser from "../visualizer/AudioAnalyzer";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import { uid } from '@ht/shared/methods';
import MobilePhoneIcon from "@ht/shared/fonts/deos-pis/mobilephone";
import OfficeIcon from "@ht/shared/fonts/deos-pis/office-building";
import Home2Icon from "@ht/shared/fonts/deos-pis/home2";
declare global {
    interface Window {
        IVLConnect(a: string, b: string): void;
        IVLDisconnect(): void;
        NotifyReactCallHangup(): void;
        NotifyReactAppMessage(message: string): void;
        NotifyRemoteAudioChanged(): void;
        mute(): void;
        ivlRemoteAudio: HTMLAudioElement;
    }
}
interface IProps {
    handleChangeRoomStatus(status: string): void;
    mediaServerUrl: string;
}
const CallControl: FC<IProps> = ({ handleChangeRoomStatus, mediaServerUrl }) => {
    const dispatch = useAppDispatch();
    const { callState, uniqueDeviceId, callAvailable } = useAppSelector((state) => state.call);
    const { user } = useAppSelector((state) => state.auth);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);

    const wsdashurl = mediaServerUrl;
    console.log(new Date().toLocaleString(), "media server url", wsdashurl)

    const callnotifWidth = 400;
    const locationX = floatingLocation.x === 0 ? (screen.width - callnotifWidth) / 2 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 2 : floatingLocation.y
    const { ref, x, y, isDragging } = useDragging(locationX, locationY, 400, 104);
    const [isMute, setIsMute] = useState(callState.isMute ? callState.isMute : false);
    const [audio, setAudio] = useState<MediaStream>()
    const resetIncomingCall = () => {

        dispatch(callIncomingMessageReceived({} as IIncomingMessage));
        dispatch(callStateChanged({} as ICallState));
        console.log("clearing callsetate")
    }
    let timer: number;
    const [duration, setDuration] = useState(callState.duration > 0 ? callState.duration : 0);
    const [intervalId, setIntervalId] = useState(0);
    const [showAudioFX, setShowAudioFX] = useState(false)
    const [micBlocked, setMicBlocked] = useState(false)
    const [allowHangup, setAllowHangup] = useState(false)

    addEventListener("microphonePermissionEvent", () => setMicBlocked(true))


    const startTimer = () => {
        timer = window.setInterval(() => {
            setDuration(dur => dur + 1);

        }, 1000);
        setIntervalId(timer);
    };
    const stopTimer = () => {
        window.clearInterval(intervalId);
    }
    useEffect(() => {
        if (duration > 5 && !allowHangup) setAllowHangup(true)
    }, [duration])
    useEffect(() => {

        if (!user)
            return;

        if (callState.callType === "outgoing") {
            const usrid = user.userId;
            const tenantid = user.tenantId;

            const dst = callState.callDestination;
            startTimer();
            window.IVLConnect(wsdashurl, `OUTGOINGSIP_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${callState.sessionId}`);
        }
        if (callState.callType === "incoming") {
            setShowAudioFX(true)
            setAllowHangup(true)
            startTimer();
        }
        else if (callState.callType === "outgoingagent") {
            const usrid = user.userId;
            const tenantid = user.tenantId;

            const dst = callState.callDestination;
            startTimer();
            window.IVLConnect(wsdashurl, `OUTGOINGAGENT_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${callState.sessionId}`);
        }
        else if (callState.callType === "silent") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);
            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            console.log("SILENTO", callState)
            window.IVLConnect(url.href, `SILENT_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);
        }
        else if (callState.callType === "coaching") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);
            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            window.IVLConnect(url.href, `COACHING_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);

        }
        else if (callState.callType === "bargein") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);

            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            window.IVLConnect(url.href, `BARGEIN_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);

        } else if (callState.duration > 0) {
            startTimer();
        }

    }, [user])

    const setIsCalling = (val: boolean) => {
        const cstate = { ...callState };
        cstate.isCalling = val;
        dispatch(callStateChanged(cstate));
    }
    const setIsAnswered = (val: boolean) => {
        const cstate = { ...callState };
        cstate.callAnswered = val;
        dispatch(callStateChanged(cstate));
    }

    const toHHMMSS = (dur: number) => {
        const hours = Math.floor(dur / 3600);
        const minutes = Math.floor((dur - (hours * 3600)) / 60);
        const seconds = dur - (hours * 3600) - (minutes * 60);
        let strhours = hours.toString();
        let strminutes = minutes.toString();
        let strseconds = seconds.toString();

        if (hours < 10) { strhours = "0" + hours.toString(); }
        if (minutes < 10) { strminutes = "0" + minutes.toString(); }
        if (seconds < 10) { strseconds = "0" + seconds.toString(); }
        return strhours + ':' + strminutes + ':' + strseconds;
    }
    const muteCall = () => {
        setIsMute(!isMute);
        window.mute();
    }
    const hangupCall = () => {
        console.log("HANGING UP CALL")
        stopTimer();
        handleChangeRoomStatus("close");
        window.IVLDisconnect();
        if (callState.callType === "silent" || callState.callType === "coaching" || callState.callType === "bargein")
            dispatch(callSendMessage({ content: JSON.stringify({ type: "hangup", callType: callState.callType, callId: callState.callDestination }) }));
        if (callState.callType != "incoming") {
            console.log("HANGING UP CALL,DC Too")
            dispatch(setOnCall(""));
        } else {
            dispatch(setOnCall("ACW"));
        }
        setTimeout(() => {
            resetIncomingCall();
            setIsCalling(false);

        }, 2000);
    }
    useEffect(() => {
        if (micBlocked) {
            console.log("MICBLOCK HANGUP")
            hangupCall()
            resetIncomingCall()
        }
    }, [micBlocked])
    useEffect(() => {
        if (!callAvailable) {
            hangupCall();
        }
    }, [callAvailable])
    window.NotifyReactCallHangup = () => {
        console.log("NOTIFY HANGUP")
        hangupCall();
    }
    window.NotifyRemoteAudioChanged = () => {
        const RemoteAudio = window.ivlRemoteAudio.srcObject as MediaStream
        setAudio(RemoteAudio)

        console.log("ivlremoteaudio", window.ivlRemoteAudio)
    }
    window.NotifyReactAppMessage = (message) => {
        console.log("react app message", message)
        const appdata = message;
        if (appdata === 'CallAnswered') {
            setDuration(0);
            setShowAudioFX(true)
            setIsAnswered(true)

        }
    }
    useEffect(() => {
        const RemoteAudio = window.ivlRemoteAudio.srcObject as MediaStream
        setAudio(RemoteAudio)
    }, [])

    const loadIcon = (phone_type: string) => {

        if (phone_type.toLowerCase().includes("mobile"))
            return <MobilePhoneIcon className="w-[16px] h-[16px] text-primary" />
        else if (phone_type.toLowerCase().includes("office"))
            return <OfficeIcon className="w-[16px] h-[16px] text-primary" />
        else if (phone_type.toLowerCase().includes("home"))
            return <Home2Icon className="w-[16px] h-[16px] text-primary" />
    }
    const splitCallDesc = callState?.callDescription?.split(",").length > 0 ? callState?.callDescription?.split(",") : ["", ""]
    const phonetype = splitCallDesc[0]
    const phonelabel = splitCallDesc[1]
    const description = callState.callDescription ? callState.callDescription.replace(`${phonetype},${phonelabel},`, "") : ""
    const iconPhone = loadIcon(phonetype)
    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx(" draggable fixed z-[20] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                { "hidden": !overlay }
            )}>
            </div>
            <div
                ref={ref}
                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    { "bg-geyser": isDragging },
                    { "bg-white": !isDragging },
                    "draggable w-[400px] rounded-lg absolute shadow-sm bg-white z-[21] overflow-hidden min-h-[104px] p-[16px]"
                )}>

                <div className="flex flex-col justify-between items-center">

                    <div className="draggable bg-white rounded-lg text-md self-start flex flex-row">
                        <div className="draggable rounded-lg ml-[8px]">
                            <div className="draggable flex flex-col gap-[8px] items-start leading-4">
                                <span className="text-base text-grey-200 cursor-default">Audio Call {toHHMMSS(duration)}</span>
                                <span className="font-semibold text-black text-lg cursor-default">{description}</span>
                                <span className="font-semibold text-primary text-base cursor-default flex flex-row gap-2">{iconPhone}{phonelabel}</span>
                                <div className="flex flex-row">
                                    {showAudioFX && audio ?

                                        <AudioAnalyser audio={audio}></AudioAnalyser>
                                        :
                                        <span className="font-semibold text-gray-700">Calling...</span>
                                    }
                                    <div id="meeting-gallery" /*style={{ height: "calc(100vh - 80px)" }}*/>
                                        {(
                                            <>


                                                <div className={clsx("draggable absolute p-[16px] top-[0px] right-[0px] flex flex-col items-center w-[160px]")}>
                                                    <div className={clsx("draggable rounded-md bg-white h-[52px] py-[8px] px-[16px] gap-[20px] flex flex-row justify-between ")}>

                                                        <div className="flex flex-row-reverse justify-end gap-[12px] items-center">
                                                            <Button shape="ellipse" disabled={!allowHangup} onClick={hangupCall} type="button" variant="contained" color={allowHangup ? "danger" : "light"} iconButton className="w-[32px] h-[32px]">
                                                                <HangupIcon className={clsx("w-[20px] h-[20px]", { "text-gray-700": !allowHangup }, { "text-white": allowHangup })} />
                                                            </Button>
                                                            <Button shape="ellipse" onClick={muteCall} type="button" variant="contained" color={isMute ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                                {
                                                                    isMute ?
                                                                        <MuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                                        : <UnmuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />

                                                                }
                                                            </Button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>

    );
};

export default CallControl;